"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContext = void 0;
var _react = require("react");
var MenuContext = /*#__PURE__*/(0, _react.createContext)({});
exports.MenuContext = MenuContext;